var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "house-selector" }, [
    _c("div", [_vm._v("Select house:")]),
    _vm._v(" "),
    _c("div", { staticClass: "buttons" }, [
      _c("button", {
        staticClass: "house-button gryffindor",
        class: { selected: _vm.selection === "gryffindor", simple: _vm.simple },
        attrs: { type: "button" },
        on: {
          click: function($event) {
            return _vm.updateSelection("gryffindor")
          }
        }
      }),
      _vm._v(" "),
      _c("button", {
        staticClass: "house-button hufflepuff",
        class: { selected: _vm.selection === "hufflepuff", simple: _vm.simple },
        attrs: { type: "button" },
        on: {
          click: function($event) {
            return _vm.updateSelection("hufflepuff")
          }
        }
      }),
      _vm._v(" "),
      _c("button", {
        staticClass: "house-button ravenclaw",
        class: { selected: _vm.selection === "ravenclaw", simple: _vm.simple },
        attrs: { type: "button" },
        on: {
          click: function($event) {
            return _vm.updateSelection("ravenclaw")
          }
        }
      }),
      _vm._v(" "),
      _c("button", {
        staticClass: "house-button slytherin",
        class: { selected: _vm.selection === "slytherin", simple: _vm.simple },
        attrs: { type: "button" },
        on: {
          click: function($event) {
            return _vm.updateSelection("slytherin")
          }
        }
      }),
      _vm._v(" "),
      _c("button", {
        staticClass: "house-button random",
        class: { selected: _vm.selection === "random", simple: _vm.simple },
        attrs: { type: "button" },
        on: {
          click: function($event) {
            return _vm.updateSelection("random")
          }
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }